import styled, { css } from 'styled-components';

import { basic, grey } from '../../../theme/colors';
import { EventVideo } from '../../event_details';
import { Badge } from '../badge';
import { ButtonTag } from '../buttonTag';

export const StyledEventVideo = styled(EventVideo)<{ width?: string; height?: string }>`
  width: ${(p) => (p.width ? p.width : 'auto')};
  height: ${(p) => (p.height ? p.height : 'auto')};

  video {
    max-height: 75vh;
    aspect-ratio: 1920 / 1080; // make sure its displayed in the same proportions as the image snapshot
    object-fit: cover;
  }
`;

export const ImageMetadataSettingsSelectorWrapper = styled.div`
  margin-top: 20px;
`;

export const LPButtonContainer = styled.div`
  position: absolute;
  bottom: 0em;
  z-index: 10;
  display: block;
  width: 100%;
  text-align: center;
`;

export const LicensePlateWrapper = styled.div`
  margin-bottom: 24px;
`;

export const EventThumbWrapper = styled.div<{ cols: number }>`
  ${(props) =>
    props.cols === 2 &&
    css`
      width: calc(100% / 2);
    `};
  ${(props) =>
    props.cols === 3 &&
    css`
      width: calc(100% / 3);
    `};
  ${(props) =>
    props.cols === 4 &&
    css`
      width: calc(100% / 4);
    `};

  position: relative;
  display: inline-block;
  vertical-align: middle;

  &:hover {
    .pre-image-thumb {
      opacity: 1;
    }
  }
`;

interface WrapperProps {
  isVideo?: boolean;
  thumbState?: string;
  noMargin?: boolean;
}

export const EventVideoThumbnailWrapper = styled.div<WrapperProps>`
  ${(props) =>
    props.thumbState === 'approved' &&
    css`
      border: 6px solid ${basic.haydenGreen};
    `};

  ${(props) =>
    props.thumbState === 'rejected' &&
    css`
      border: 6px solid ${basic.haydenRed};
    `};

  ${(props) =>
    props.thumbState === 'skipped' &&
    css`
      border: 6px solid ${grey.haydenGreyShade3};
    `};

  transition: 150ms linear all;
  top: 0;
  ${(props) =>
    props.noMargin
      ? css`
          margin: 0;
        `
      : css`
          margin: 4px;
        `}
  position: relative;

  ${(props) =>
    props.isVideo &&
    css`
      z-index: 10;
      :hover {
        span:last-of-type {
          bottom: 90px;
        }
        span:first-of-type {
          bottom: 78px;
        }
        span,
        button {
          bottom: 68px;
        }
      }
    `};
`;

export const GridEventLPRWrapper = styled.span<{ showLicensePlates?: boolean }>`
  opacity: 0;
  pointer-events: none;
  position: absolute;
  left: 2.5em;
  bottom: 2em;
  transition: 150ms linear all;
  z-index: 2;
  ${({ showLicensePlates }) =>
    showLicensePlates &&
    css`
      opacity: 1;
      pointer-events: all;
    `}
`;

export const UploadStatus = styled(Badge)`
  position: absolute;
  bottom: 8px;
  transition: 150ms linear all;
  left: 8px;
  color: #fff;
  background: ${basic.haydenAccent};
  text-align: center;
  z-index: 2;
`;

export const Description = styled(Badge).attrs(() => ({
  variant: 'secondary',
}))`
  position: absolute;
  bottom: 18px;
  left: 50%;
  transform: translateX(-50%) translateY(50%);
  margin: 0 !important;
  transition: 150ms linear all;
`;

export const ButtonEventView = styled(ButtonTag)`
  bottom: 8px;
  position: absolute;
  right: 8px;
  transition: 150ms linear all;
  font-size: 16px;
  font-weight: 500;
  height: 40px;
  line-height: 24px;
  margin: 0;
  padding: 7px 16px;
  white-space: nowrap;
  z-index: 9;
`;
